import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'

import '@/assets/css/core.css'
import '@/assets/css/extended.css'
import '@/assets/css/font.css'
import '@/assets/css/color.css'
import '@/assets/css/table.css'
import '@/assets/css/panel.css'
import '@/assets/css/actioncard.css'
import '@/assets/css/layout-dashboard.css'
import '@/assets/css/pills.css'

import { initializeMsal, restoreIdentityFromMsal, msalInstance } from './plugins/msal'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

async function bootstrapApp() {
  await initializeMsal()

  const app = createApp(App)

  app.provide('msalInstance', msalInstance)
  app.use(pinia)

  await restoreIdentityFromMsal()

  app.use(router)
  await router.isReady()

  app.mount('#app')
}

bootstrapApp()